import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const webViewPropertyOwnerShortTermAccommodationRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    buildingType: validationRules.buildingType,
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    startRentalDate: validationRules.startRentalDateRequired,
  },
  costs: {
    price: validationRules.price,
    pricePeriodType: validationRules.pricePeriodType,
    additionalCosts: validationRules.additionalCosts,
    heatingCosts: validationRules.heatingCosts,
    deposit: validationRules.deposit,
  },
  description: {
    ...defaultDescription,
    adFurnishingNote: validationRules.adFurnishingNote,
  },
  contactInfo: defaultContactInfo,
  objectDetails: {
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    minRentalTime: validationRules.minRentalTime,
    maxRentalTime: validationRules.maxRentalTime,
    maxNumberOfPersons: validationRules.maxNumberOfPersons,
  },
  construction: defaultConstruction,
  otherFacilities: {
    noParkingSpaces: validationRules.noParkingSpaces,
    parkingSpaceRent: validationRules.parkingSpaceRent,
  },
}
